import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { getFirstAccessibleAdminPath, hasAdminPermission } from '../utils/adminPermissions';

export default function PermissionRoute({ permission, children }) {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);

  if (!token) return <Navigate to="/login" replace />;
  if (hasAdminPermission(user, permission)) return children;

  return <Navigate to={getFirstAccessibleAdminPath(user)} replace />;
}
